import React from "react";
import "./financial-services.css";
import { useTranslation } from "react-i18next";
import Header from "../../../components/header/header";
import BannerComponent from "../../../components/bannerComponent/bannerComponent";
import BenefitsCardsComponent from "../../../components/benefitsCardsComponent/benefitsCardsComponent";
import ButtonLinkComponent from "../../../components/buttonLink/buttonLink";
import Footer from "../../../components/footer/footer";

const FinancialServices = () => {
  const { t } = useTranslation();

  function openBooking() {
    const BOOKING_URL =
      "https://outlook.office365.com/book/G07e86683359a41f58322cab8b2047723@5igsolutions.com/?ismsaljsauthenabled=true&RefID=FINANCIAL_SERVICES";

    window.open(BOOKING_URL, "_blank", "noopener,noreferrer");
  }

  const heroData = {
    title: t("FINANCIALS_MAIN_BANNER_TITLE_1"),
    title2: t("FINANCIALS_MAIN_BANNER_TITLE_2"),
    text: t("FINANCIALS_MAIN_SUB_DESCRIPTION"),
    className: "financialsHeroBanner",
    chipText: t("FINANCIALS_HERO_CHIP"),
  };

  const services = [
    { title: t("FINANCIALS_MAIN_SERVICE_1_TITLE"), icon: "accounting-icon.svg" },
    { title: t("FINANCIALS_MAIN_SERVICE_2_TITLE"), icon: "tax-icon.svg" },
    { title: t("FINANCIALS_MAIN_SERVICE_3_TITLE"), icon: "payroll-icon.svg" },
    { title: t("FINANCIALS_MAIN_SERVICE_4_TITLE"), icon: "budgeting-icon.svg" },
    { title: t("FINANCIALS_MAIN_SERVICE_5_TITLE"), icon: "reporting-icon.svg" },
    { title: t("FINANCIALS_MAIN_SERVICE_6_TITLE"), icon: "compliance-icon.svg" },
    { title: t("FINANCIALS_MAIN_SERVICE_7_TITLE"), icon: "closing-icon.svg" },
    { title: t("FINANCIALS_MAIN_SERVICE_8_TITLE"), icon: "call-center-icon.svg" },
    { title: t("FINANCIALS_MAIN_SERVICE_9_TITLE"), icon: "custom-financials-icon.svg" },
  ];

  const keyData = [
    { title: t("FINANCIALS_MAIN_KEY_DATA_1_TITLE") },
    { title: t("FINANCIALS_MAIN_KEY_DATA_2_TITLE") },
    { title: t("FINANCIALS_MAIN_KEY_DATA_3_TITLE") },
  ];

  const featuresData = [
    {
      title: t("FINANCIALS_MAIN_FEATURE_1_TITLE"),
      text: t("FINANCIALS_MAIN_FEATURE_1_TEXT"),
      imgSrc: "/img/front-view-graph-made-out-coins 1.jpg",
    },
    {
      title: t("FINANCIALS_MAIN_FEATURE_2_TITLE"),
      text: t("FINANCIALS_MAIN_FEATURE_2_TEXT"),
      imgSrc: "/img/person-taking-notes-notebook-while-working-from-home 2.jpg",
    },
    {
      title: t("FINANCIALS_MAIN_FEATURE_3_TITLE"),
      text: t("FINANCIALS_MAIN_FEATURE_3_TEXT"),
      imgSrc: "/img/hand-man-playing-chess-business-planning-comparison-metaphor-selective-focus 1.jpg",
    },
    {
      title: t("FINANCIALS_MAIN_FEATURE_4_TITLE"),
      text: t("FINANCIALS_MAIN_FEATURE_4_TEXT"),
      imgSrc: "/img/top-viewtop-view-manager-employee-doing-teamwork-business-office-looking-charts-laptop-display 1.jpg",
    },
  ];

  const cardBenefitsData = [
    {
      title: t("FINANCIALS_MAIN_BENEFIT_1_TITLE"),
      text: t("FINANCIALS_MAIN_BENEFIT_1_TEXT"),
      img: "/img/person-taking-notes-notebook-while-working-from-home 1.jpg",
    },
    {
      title: t("FINANCIALS_MAIN_BENEFIT_2_TITLE"),
      text: t("FINANCIALS_MAIN_BENEFIT_2_TEXT"),
      img: "/img/person-taking-notes-notebook-while-working-from-home 3.jpg",
    },
    {
      title: t("FINANCIALS_MAIN_BENEFIT_3_TITLE"),
      text: t("FINANCIALS_MAIN_BENEFIT_3_TEXT"),
      img: "/img/person-taking-notes-notebook-while-working-from-home 4.jpg",
    },
    {
      title: t("FINANCIALS_MAIN_BENEFIT_4_TITLE"),
      text: t("FINANCIALS_MAIN_BENEFIT_4_TEXT"),
      img: "/img/person-taking-notes-notebook-while-working-from-home 5.jpg",
    },
  ];

  function InsightCard({ text }) {
    return (
      <article className="financialsInsightCard">
        <p>{text}</p>
      </article>
    );
  }

  function FeatureCard({ img, title, text }) {
    return (
      <article className="financialsFeatureCard">
        <div className="financialsFeatureMedia">
          <img src={img} alt={title} />
        </div>

        <div className="financialsFeatureContent">
          <h3>{title}</h3>
          <p>{text}</p>
        </div>
      </article>
    );
  }

  function StartCard({ img, title, text, index }) {
    return (
      <article className="financialsStartCard">
        <div className="financialsStartNumber">{index + 1}</div>

        <div className="financialsStartMedia">
          <img src={img} alt={title} />
        </div>

        <div className="financialsStartContent">
          <h3>{title}</h3>
          <p>{text}</p>
        </div>
      </article>
    );
  }

  return (
    <>
      <Header />

      <main className="financialsPage">
        <section className="financialsHero financialsHeroFull">
          <div className="financialsHeroBannerFull">
            <BannerComponent
              translateTitle={`${heroData.title} ${heroData.title2}`}
              translateText={heroData.text}
              className={heroData.className}
              classNameSide="l"
              translateButton={t("FINANCIALS_MAIN_BANNER_BUTTON")}
              chipText={heroData.chipText}
              onClick={openBooking}
              headingTag="h1"
            />
          </div>
        </section>

        <section className="financialsProblem">
          <div className="financialsProblemWrap">
            <div className="financialsSectionIntro">
              <h2>{t("FINANCIALS_MAIN_PROBLEM_TITLE")}</h2>
              <p>
                {t("FINANCIALS_MAIN_PROBLEM_INTRO")}
              </p>
            </div>

            <div className="financialsProblemGrid">
              <div className="financialsInsightsGrid">
                {keyData.map((item, index) => (
                  <InsightCard key={index} text={item.title} />
                ))}
              </div>

              <div className="financialsProblemContent">
                <div className="financialsProblemText">
                  <p>{t("FINANCIALS_MAIN_PROBLEM_DESCRIPTION_1")}</p>
                  <p>{t("FINANCIALS_MAIN_PROBLEM_DESCRIPTION_2")}</p>
                </div>

                <div className="financialsProblemMedia">
                  <img
                    src="/img/smiley-woman-working-with-laptop-papers-office 1.jpg"
                    alt={t("FINANCIALS_MAIN_PROBLEM_TITLE")}
                  />
                </div>
              </div>
            </div>

          </div>
        </section>

        <section className="financialsServices">
          <div className="financialsSectionIntro">
            <h2>{t("FINANCIALS_MAIN_SERVICES_TITLE")}</h2>
            <p>
              {t("FINANCIALS_MAIN_SERVICES_DESC", {
                defaultValue:
                  "Servicios financieros integrales diseñados para optimizar el control, la eficiencia y la toma de decisiones de su negocio.",
              })}
            </p>
          </div>

          <BenefitsCardsComponent
            title=""
            cardsData={services}
          />
        </section>

        <section className="financialsWhy">
          <div className="financialsSectionIntro">
            <h2>{t("FINANCIALS_MAIN_WHY_CHOOSE_US_TITLE")}</h2>
          </div>

          <div className="financialsWhyGrid">
            {featuresData.map((feature, index) => (
              <FeatureCard
                key={index}
                title={feature.title}
                text={feature.text}
                img={feature.imgSrc}
              />
            ))}
          </div>
        </section>

        <section className="financialsStart">
          <div className="financialsSectionIntro">
            <h2>{t("FINANCIALS_MAIN_HOW_TO_GET_STARTED_TITLE")}</h2>
          </div>

          <div className="financialsStartGrid">
            {cardBenefitsData.map((item, index) => (
              <StartCard
                key={index}
                index={index}
                title={item.title}
                text={item.text}
                img={item.img}
              />
            ))}
          </div>
        </section>

        <section className="financialsCta">
          <div className="financialsCtaInner">
            <div className="financialsCtaContent">
              <h2>{t("FINANCIALS_MAIN_CTA_TITLE")}</h2>
              <div className="financialsCtaText">
                <p>
                  {t("FINANCIALS_MAIN_CTA_DESC",)}
                </p>
              </div>
            </div>

            <ButtonLinkComponent
              translateButton={t("FINANCIALS_MAIN_BANNER_BUTTON")}
              className="buttonFinancials"
              url={
                "https://outlook.office365.com/book/G07e86683359a41f58322cab8b2047723@5igsolutions.com/?RefID=FINANCIAL_SERVICES"
              }
              blank={true}
            />
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default FinancialServices;